<template>
  <div class="login" >
    <UserHeader  :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']"></UserHeader>

    <div class="login_container"  :class="[language == 'zh'?'zhFamily':'enfamily']">
      <div class="login_container_box">
        <div class="login_container_box_img">
          <img src="../assets/image/User/login_icon.png" alt />
        </div>
        <div class="login_container_box_login">
          <Login></Login>
        </div>
      </div>
    </div>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
export default {
  components: {
    UserHeader: () => import("@/components/User/UserHeader.vue"),
    Login: () => import("@/components/User/Login.vue"),
    UserFooter: () => import("@/components/User/UserFooter.vue"),
    //  Footer: () => import("@/components/PublicComponents/Footer/Footer.vue")
  }
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  flex-direction: column;

  .login_container {
    width: 100%;
    // height: calc(100vh);
    background: url("../assets/image/User/background_login.png");
    background-repeat: no-repeat;
    background-size: cover;

    background-position: center 0;
    .login_container_box {
     
      width: 1200px;
      // padding-bottom: 100px;
      margin: auto;
      display: flex;
      justify-content: space-between;

      .login_container_box_img {
        margin-top: 100px;
        width: 700px;
        // height: 415px;
        img {
          width: 100%;
          // height: 415px;
        }
      }
      .login_container_box_login {
       
        margin-top: 100px;
        border-radius: 4px;
        min-width: 464px;
        // min-height: 600px;
        // background: #fff;
      }
    }
  }
}
</style>